import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Define which materials fit this bike model
 * @primary Compatible materials list
 * @persona paola-admin-belora
 */
export const Route = createFileRoute(
  "/app/c/$customerSlug/bike-models/$id/materials",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
